import { render, staticRenderFns } from "./welcome-popup.html?vue&type=template&id=71b3a4f1&scoped=true&"
import script from "./welcome-popup.js?vue&type=script&lang=js&"
export * from "./welcome-popup.js?vue&type=script&lang=js&"
import style0 from "./welcome-popup.css?vue&type=style&index=0&id=71b3a4f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b3a4f1",
  null
  
)

export default component.exports